var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-list" },
    [
      _c(
        "Search",
        _vm._g(_vm._b({}, "Search", _vm.filterAttrs, false), _vm.filterEvent)
      ),
      _c(
        "Table",
        _vm._g(
          _vm._b(
            {
              attrs: { "list-query-params": _vm.listQueryParams },
              on: {
                "update:listQueryParams": function ($event) {
                  _vm.listQueryParams = $event
                },
                "update:list-query-params": function ($event) {
                  _vm.listQueryParams = $event
                },
              },
            },
            "Table",
            _vm.tableAttrs,
            false
          ),
          _vm.tableEvent
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }